import { useEffect, useRef } from 'react';

// Events trigger a short, coalesced refresh; polling repairs missed notifications.
export default function useLiveRefresh(callback, enabled, intervalMs, eventName) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    let busy = false;
    let pending = false;
    let stopped = false;
    let eventTimer;
    const refresh = async () => {
      if (stopped || document.visibilityState !== 'visible') return;
      if (busy) { pending = true; return; }
      busy = true;
      try { await callbackRef.current(); } catch (_) { /* Next refresh retries. */ }
      finally {
        busy = false;
        if (pending && !stopped) { pending = false; eventTimer = setTimeout(refresh, 250); }
      }
    };
    const schedule = () => { clearTimeout(eventTimer); eventTimer = setTimeout(refresh, 250); };
    const timer = setInterval(refresh, intervalMs);
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', schedule);
    if (eventName) window.addEventListener(eventName, schedule);
    return () => {
      stopped = true;
      clearInterval(timer);
      clearTimeout(eventTimer);
      window.removeEventListener('focus', schedule);
      document.removeEventListener('visibilitychange', schedule);
      if (eventName) window.removeEventListener(eventName, schedule);
    };
  }, [enabled, intervalMs, eventName]);
}
